/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'

import { fetchConsumption, fetchPeriods } from '../../usecases/billing'

import {
  consumptionModel,
  LoadFromModal
} from '../../../domain/models/billing-models'
import Billing from '../../../presentation/pages/my-data/billing'
import { formatDate } from '../../../presentation/utils'

const BilingFactory = () => {
  const [consumition, setConsumition] = useState<consumptionModel[]>([])
  const [billingForms, setBillingForms] = useState<any[]>([])
  const [billing, setBilling] = useState<any[]>([])

  useEffect(() => {
    ;(async () => {
      const loadConsumption = await fetchConsumption('').load()

      const temp = loadConsumption.map((item: any) => ({
        ...item,
        dataConsumo: formatDate(item.dataConsumo)
      }))
      setConsumition(temp)

      setBillingForms([
        {
          nome: 'Vitor Reis',
          ultimos4digitos: '1025',
          ativo: true,
          bandeira: 'visa',
          id: 15
        },
        {
          nome: 'Joao Reis',
          ultimos4digitos: '1541',
          ativo: false,
          bandeira: 'mastercard',
          id: 16
        }
      ])
    })()
  }, [])

  const loadFromModal = async (period: string): Promise<LoadFromModal> => {
    const loadDateOptions = await fetchPeriods().load()
    const loadConsumption = await fetchConsumption(period).load()

    const temp = loadConsumption.map((item: any) => ({
      ...item,
      dataConsumo: formatDate(item.dataConsumo)
    }))

    return {
      periods: loadDateOptions,
      consumition: temp
    }
  }

  return (
    <Billing
      consumition={consumition.filter((_, index) => index <= 2)}
      loadFromModal={loadFromModal}
      billingForms={billingForms}
      billing={billing}
    />
  )
}
export default BilingFactory
